import NextLink from 'next/link'
import { Button, Center, Flex, VStack, Text } from '@chakra-ui/react'
import { ITalktoSales } from '@/types/strapi/homePage.interface'
import { ContainerBase } from '@/components/containers/ContainerBase'

export const TalktoSales = ({
  talkToSales,
}: {
  talkToSales: ITalktoSales[]
}) => {
  const cms = talkToSales?.length > 0 ? talkToSales[0] : null

  if (!cms) return null

  return (
    <Center width="100%" background="gradient.brand">
      <ContainerBase py="32px" maxWidth={{ xl: '1216px', xxl: '1216px' }}>
        <Flex
          width="100%"
          backgroundColor="black"
          background={`linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), url("/img/talk-to-sales-bg.png") lightgray 50% / cover no-repeat`}
          rounded="md"
          padding={{ base: '32px', md: '64px' }}
          alignItems="flex-start"
          gridGap="10px"
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <VStack flex="1" alignItems="flex-start">
            <Text fontSize={'24px'} variant="brandGradient" fontWeight="600">
              {cms?.subtitle}
            </Text>
            <Text
              variant="spaceGrotesk"
              color="white"
              fontSize={'32px'}
              fontWeight={300}
              lineHeight="normal"
              pr={{ base: 0, md: 10, lg: '74px' }}
            >
              {cms?.title}
            </Text>
          </VStack>
          <VStack
            flex="1"
            alignItems="flex-start"
            spacing="16px"
            maxW={'480px'}
          >
            <Text color="whiteAlpha.800" fontSize={'24px'} lineHeight={1.33}>
              {cms?.description}
            </Text>
            {cms?.button && (
              <NextLink
                href={cms?.button?.url || '/contact-sales'}
                target={cms?.button?.newTab ? '_blank' : ''}
                passHref
              >
                <Button
                  variant="alwaysWhite"
                  width={{ base: '100%', md: '200px' }}
                  height="50px"
                >
                  {cms?.button?.text}
                </Button>
              </NextLink>
            )}
          </VStack>
        </Flex>
      </ContainerBase>
    </Center>
  )
}
